import { CommonProperty } from '@/modules/health/rater/models/DXP/ConfigurationsProperties'
import { stringToNumber } from '@/utils/converterUtils'

export default class DentalRelationshipType extends CommonProperty {
  holder: boolean
  maxSelectable: number | null

  constructor(data: DentalRelationshipType) {
    super(data)
    this.holder = data.holder
    this.maxSelectable = stringToNumber(String(data.maxSelectable))
  }
}
